import { loadHeaders, setHeaders } from '@actions/headers.action';
import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { HeadersService } from '@services/headers/headers.service';
import { exhaustMap, map } from 'rxjs';

@Injectable()
export class HeadersEffect {
  private actions$ = inject(Actions);
  private headersService = inject(HeadersService);

  loadHeaders$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(loadHeaders),
      exhaustMap(() =>
        this.headersService.getHeadersFromHomeRoute().pipe(
          map(({ geoClientCountry, geoClientIp }) => {
            return setHeaders({
              geoClientCountry,
              geoClientIp
            });
          }),
        ),
      ),
    );
  });
}
